export enum ExamLevelWithDescriptionEnum {

  A2_NICHT_ERFULLT = 'A2 nicht erfüllt',
  A2_ERFULLT = 'A2 erfüllt',
  A2_GUT_ERFULLT = 'A2 gut erfüllt',
  A2_SEHR_GUT_ERFULLT = 'A2 sehr gut erfüllt',
  B1_ERFULLT = 'B1 erfüllt',
  B1_GUT_ERFULLT = 'B1 gut erfüllt',
  B1_SEHR_GUT_ERFULLT = 'B1 sehr gut erfüllt'
}
